/**
 * Icone de uma figura/poligono que
 * representar o Buffer
 */
export const BufferIcon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.79179 17.0859L2.53955 9.83594L7.71812 2.58594L17.0396 11.9074L7.79179 17.0859Z"
      stroke="#BEC7DC"
      strokeWidth="3.5"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Icone de lixeira usado 
 * para deletar o buffer
 */
export const TrashIcon = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.94025 1.64773H4.31525V1.27273C4.31525 0.776926 4.71718 0.375 5.21298 0.375H7.75843C8.25424 0.375 8.65616 0.776926 8.65616 1.27273V1.64773H9.03116H12.213C12.3573 1.64773 12.4743 1.76474 12.4743 1.90909V3.18182C12.4743 3.32617 12.3573 3.44318 12.213 3.44318H11.5766H11.2016V3.81818V12.7273C11.2016 13.2231 10.7997 13.625 10.3039 13.625H2.66752C2.17172 13.625 1.7698 13.2231 1.7698 12.7273V3.81818V3.44318H1.3948H0.758434C0.614087 3.44318 0.49707 3.32617 0.49707 3.18182V1.90909C0.49707 1.76474 0.614087 1.64773 0.758434 1.64773H3.94025ZM4.57662 4.71591C4.01805 4.71591 3.56525 5.16871 3.56525 5.72727V10.8182C3.56525 11.3767 4.01806 11.8295 4.57662 11.8295C5.13518 11.8295 5.58798 11.3767 5.58798 10.8182V5.72727C5.58798 5.16871 5.13518 4.71591 4.57662 4.71591ZM8.3948 4.71591C7.83624 4.71591 7.38343 5.16871 7.38343 5.72727V10.8182C7.38343 11.3767 7.83624 11.8295 8.3948 11.8295C8.95336 11.8295 9.40616 11.3767 9.40616 10.8182V5.72727C9.40616 5.16871 8.95336 4.71591 8.3948 4.71591Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="0.75"
    />
  </svg>
);

/**
 * Icone de confirmação(check)
 * usado para salvar o buffer feito
 */
export const CheckIcon = (props) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.23235 13.7998C5.91317 13.7998 5.60601 13.6733 5.37926 13.4466L0.554485 8.62179C0.0834008 8.15042 0.0834008 7.38697 0.554485 6.91589C1.02585 6.4448 1.7893 6.4448 2.26039 6.91589L6.1617 10.8172L14.341 1.22322C14.7733 0.716954 15.5342 0.6558 16.0416 1.08779C16.5485 1.52006 16.609 2.28156 16.1771 2.78839L7.15022 13.3759C6.93185 13.632 6.61659 13.7853 6.2801 13.7987C6.26418 13.7992 6.24827 13.7998 6.23235 13.7998Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);

/**
 * Icone de fechamento(close)
 * usado para fechar modal da ferramenta
 */
export const CloseIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 9.92969 1.19043)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="12"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.44531 0.0766602)"
      stroke="#ABABAB"
      strokeWidth="1.5"
    />
  </svg>
);
